import { useContext } from "react";

import { MapPanelContext } from "./withMapPanelWrapper";
import { getDisplayName } from "../../Utils/getDisplayName";

export function useMapPanel() {
  return useContext(MapPanelContext);
}

export default function withMapPanel(WrappedComponent) {
  const WithMapPanel = props => {
    return (
      <MapPanelContext.Consumer>
        {({ id }) => <WrappedComponent {...{ ...props, panelId: id }} />}
      </MapPanelContext.Consumer>
    );
  };

  WithMapPanel.displayName = `WithMapPanel(${getDisplayName(
    WrappedComponent
  )})`;

  return WithMapPanel;
}
